module.exports = __webpack_public_path__ + "img/479.56580a5c.jpg";